// extracted by mini-css-extract-plugin
export var background = "aboutECHOVideoSection-module--background--225f0";
export var container = "aboutECHOVideoSection-module--container--90aa7";
export var description = "aboutECHOVideoSection-module--description--7d56d";
export var heading = "aboutECHOVideoSection-module--heading--56a59";
export var highlight = "aboutECHOVideoSection-module--highlight--e963f";
export var video = "aboutECHOVideoSection-module--video--05db9";